module.exports = __webpack_public_path__ + "static/img/4369_phase_function_Paper_PointsHejduk_Prediction.8cf9222.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4369_phase_function_Paper_PointsHejduk_Prediction.png
// module id = bDo8
// module chunks = 0